import { useState, useEffect } from 'react';
import DynaLoader from './DynaLoader';
import { Link } from 'react-router-dom';
import matic from '../images/polygon.svg';

import { fetchCachedAccountDetails, subscribeToCachedAccount } from '../utils/LocalStorage';

const MintPriceComponent = (props: any) => {
  // Whether the connected account can afford the mint. Unknown until we have
  // both a price and a connected account -- the price itself is public and
  // shows regardless.
  const [balance, setBalance] = useState<string | null>(null);
  const [hasEnoughForMint, setHasEnoughForMint] = useState(true);

  const mintPrice = props.mintPrice;
  const formattedMintPrice = props.formattedMintPrice;

  useEffect(() => {
    if (mintPrice === null || mintPrice === undefined) {
      return;
    }

    // Read the connected account rather than asking the wallet: querying it
    // here would establish a session the user never started, and there is
    // nothing to compare against until they connect.
    const compareToBalance = (accountDetails = fetchCachedAccountDetails()) => {
      if (accountDetails === null) {
        setBalance(null);
        setHasEnoughForMint(true);
        return;
      }
      setBalance(accountDetails.displayBalance);
      setHasEnoughForMint(BigInt(accountDetails.weiBalance) >= BigInt(mintPrice));
    }

    compareToBalance();

    // Follow connects, disconnects and account switches.
    return subscribeToCachedAccount((accountDetails) => compareToBalance(accountDetails));
  }, [mintPrice]);

  // Only spin while the fetch is genuinely in flight. A null price once
  // loading has finished means the fetch failed -- say so instead of
  // spinning forever.
  if (props.loading) {
    return (
      <div>
        Mint price: <DynaLoader variant="inline" label="Loading mint price" />
      </div>
    );
  }

  if (formattedMintPrice === null || formattedMintPrice === undefined) {
    return (
      <div>
        Mint price unavailable. Please refresh the page.
      </div>
    );
  }

  if (balance !== null && !hasEnoughForMint) {
    return (
      <div>
        The mint price is <img src={matic} alt="MATIC logo" className='mintMatic' />{formattedMintPrice}, however your balance is <img src={matic} alt="MATIC logo" className='mintMatic' />{balance}. See the <Link to="/howto">How to guide</Link> for info on acquiring MATIC.
      </div>
    );
  }

  return (
    <div>
      Mint price: <img src={matic} alt="MATIC logo" className='mintMatic' />{formattedMintPrice}
    </div>
  );
}

export default MintPriceComponent;
